import Image from "next/image";

const BannerSection = ({ data }) => {
  const { title, description, backgroundImage } = data;

  return (
    <section className="relative w-full h-[300px] md:h-[400px] flex items-center justify-center text-center text-white">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src={backgroundImage}
          alt={title}
          fill
          className="object-cover"
          priority
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-[#00000087]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6">
        <h1 className="text-3xl md:text-4xl font-bold text-[#33c1c7] mb-3">
          {title}
        </h1>
        <p className="max-w-3xl mx-auto text-[19px] text-[#FFFFFFDE]">
          {description}
        </p>
      </div>
    </section>
  );
};

export default BannerSection;
